export const TAAL_OPSLAG = "eo-taal";

export const talen = [
  { code: "nl", label: "Nederlands", vlag: "🇳🇱" },
  { code: "en", label: "English", vlag: "🇬🇧" },
] as const;

export type TaalCode = (typeof talen)[number]["code"];

const nlTeksten = {
  // Navigatie
  navHome: "Home",
  navDiensten: "Diensten",
  navPlaatsen: "Plaatsen",
  navHoeHetWerkt: "Hoe het werkt",
  navVeelgesteldeVragen: "Veelgestelde vragen",
  navContact: "Contact",
  navAanmelden: "Meld je aan als elektricien",
  navInloggen: "Inloggen",
  taalKiezen: "Taal kiezen",
  taal: "Taal:",
  menuOpenen: "Menu openen",
  menuSluiten: "Menu sluiten",
  zoekPlaceholder: "Zoek diensten of plaatsen…",
  zoekDiensten: "Diensten",
  zoekPlaatsen: "Plaatsen",
  zoekGeenResultaten: "Geen resultaten gevonden",
  nieuwsTitel: "Laatste nieuws",
  nieuwsAlles: "Bekijk alle artikelen",
  nieuwsLees: "Lees artikel",
  nieuws1Titel: "Laadpaal installeren: kosten en mogelijkheden",
  nieuws1Tekst: "Een laadpaal thuis laten installeren? Bekijk de mogelijkheden, richtprijzen en aandachtspunten en vergelijk vrijblijvend offertes van elektriciens.",
  nieuws2Titel: "Groepenkast uitbreiden voor inductie: de complete gids voor 2026",
  nieuws2Tekst: "Wil je de groepenkast uitbreiden voor inductie? Ontdek alles over de kookgroep, 3-fase krachtstroom en Perilex in deze complete gids. Lees direct alle tips!",
  nieuws3Titel: "Perilex aansluiten: wat kost het en wat moet je weten?",
  nieuws3Tekst: "Perilex aansluiten voor een inductiekookplaat? We vertellen je wat het kost, aan welke regels je moet denken en hoe een erkende elektricien het veilig aanlegt.",
  nieuws4Titel: "Zonnepanelen en omvormer plaatsen: kosten en tips in 2026",
  nieuws4Tekst: "Hoeveel kost het plaatsen van zonnepanelen met omvormer? Bekijk onze prijsgids voor 2026 en ontdek waar je op moet letten bij de installatie.",

  // Footer
  footerIntro:
    "Vergelijk gratis en vrijblijvend offertes van erkende elektriciens bij jou in de buurt. Eén aanvraag, meerdere prijzen.",
  footerPaginas: "Pagina's",
  footerKlussen: "Populaire klussen",
  footerPlaatsen: "Populaire plaatsen",
  footerElektricien: "Elektricien",

  // QuoteForm
  postcode: "Postcode",
  typeKlus: "Type klus",
  gratisOffertes: "Gratis offertes",
  formVoetnoot: "Kosteloos en Vrijblijvend · Binnen enkele minuten is de aanvraag gedaan ",
  klusOpties: [
    "Groepenkast vervangen",
    "Laadpaal installeren",
    "Stopcontacten bijplaatsen",
    "Perilex aansluiten",
    "Woning herbedraden",
    "Verlichting aanleggen",
    "Storing verhelpen",
    "Camerabeveiliging",
    "Inbraakbeveiliging (alarmsysteem)",
    "Intercom / videodeurbel",
    "Databekabeling aanleggen",
  ],
  // Weergavelabels per interne waarde; de opgeslagen waarde blijft ongewijzigd.
  klusLabels: {
    "Databekabeling aanleggen": "Netwerktechniek",
    "Inbraakbeveiliging (alarmsysteem)": "Inbraakbeveiliging",
  } as Record<string, string>,

  // Banner
  heroBadge: "",
  heroTitelRegel1: "Vind de beste vakman",
  heroTitelRegel2: "voor in en om je huis",
  heroVoordeel1: "Erkende elektriciens",
  heroVoordeel2: "Gratis en vrijblijvend",
  heroVoordeel3: "Binnen 1 minuut geregeld",
  heroVoordeel3Mobiel: "Snel geregeld",
  heroSterrenLabel: "4,7 van 5 sterren",
  heroScore: "4,7",
  heroReviews: "gemiddeld uit 120+ reviews",

  // Hoe werkt het
  hoeTitel: "Hoe werkt het?",
  hoeIntro: "In drie eenvoudige stappen van aanvraag naar offertes van erkende elektriciens.",
  hoeStap1Titel: "Beschrijf je project",
  hoeStap1Tekst:
    "Vul je postcode in en kies het type werk. Vertel wat je wensen zijn, zodat we de juiste elektriciens kunnen matchen.",
  hoeStap2Titel: "Vergelijk elektriciens",
  hoeStap2Tekst:
    "We selecteren tot 5 erkende bedrijven uit jouw regio. Je ontvangt hun offertes en kunt rustig vergelijken.",
  hoeStap3Titel: "Kies jouw elektricien",
  hoeStap3Tekst:
    "Vergelijk prijs, planning en reviews. Kies zelf wie je inschakelt, of doe helemaal niets met de offertes.",
  hoeKnop: "Start je aanvraag →",

  // USP's
  uspBesparenTitel: "ThuisbatterijOffertes.com",
  uspBesparenTekst: "Prijzen van meerdere elektriciens naast elkaar.",
  uspMinuutTitel: "WarmtepompOffertes.com",
  uspMinuutTekst: "Postcode en klus invullen is genoeg.",
  uspVakmensenTitel: "BeveiligingOffertes.com",
  uspVakmensenTekst: "Gecontroleerde bedrijven met reviews.",
  uspKaart4Titel: "GroepenkastOffertes.com",
  uspKaart4Tekst: "Prijzen van meerdere elektriciens naast elkaar.",
  uspKaart5Titel: "SmarthomeOffertes.com",
  uspKaart5Tekst: "Postcode en klus invullen is genoeg.",
  uspKaart6Titel: "offerto",
  uspKaart6Tekst: "Gecontroleerde bedrijven met reviews.",
  iconPortemonnee: "Portemonnee icoon",
  iconKlok: "Klok icoon",
  iconDocument: "Document icoon",

  // Kosten
  kostenEyebrow: "Richtprijzen",
  kostenTitel: "Wat kost een elektricien?",
  kostenIntro:
    "Richtprijzen inclusief materiaal en arbeid. De werkelijke prijs hangt af van je woning en situatie. Vergelijk elektricien offertes van betrouwbare bedrijven en bespaar tot 40% op de kosten van je project.",
  kostenBespaar: "Bespaar tot 40% door offertes naast elkaar te leggen.",
  kostenLink: "Bekijk alle diensten",
  kostenKolomKlus: "Klus",
  kostenKolomPrijs: "Richtprijs",
  klusGroepenkast: "Groepenkast vervangen",
  klusLaadpaal: "Laadpaal installeren",
  klusStopcontact: "Stopcontact bijplaatsen",
  klusHerbedraden: "Woning herbedraden",
  klusVerlichting: "Verlichting aanleggen",
  klusStoring: "Storing verhelpen",

  // Reviews
  reviewsEyebrow: "Ervaringen",
  reviewsTitel: "Wat klanten zeggen",
  reviewsScore: "4,7 / 5",
  review1: "Binnen één uur had ik drie offertes in mijn mailbox. Scheelde me honderden euro's.",
  review1Naam: "Frans J., Utrecht",
  review2: "Fijn dat je eerst kunt vergelijken voordat je iemand kiest. Snelle en nette service.",
  review2Naam: "X. Schouten, Breda",

  // Slot-CTA
  ctaTitel: "Ontvang gratis offertes en bespaar tot 40%",
  ctaTekst: "Vul je postcode in en ontvang vrijblijvend prijzen van elektriciens uit je regio.",
  ctaVink1: "Kosteloos en vrijblijvend",
  ctaVink2: "Binnen 5 minuten aangevraagd",

  // Netwerk
  netwerkTitel: "Onderdeel van het Offertes-netwerk",
  netwerkIntro: "Gespecialiseerde vergelijkingssites voor elk type installatie.",
  netwerkThuisbatterij: "Thuisbatterij laten installeren",
  netwerkWarmtepomp: "Warmtepomp offertes vergelijken",
  netwerkBeveiliging: "Alarm, camera's en intercom",
  netwerkGroepenkast: "Groepenkast vervangen of uitbreiden",
  netwerkSmarthome: "Slimme verlichting en domotica",
  netwerkElektricien: "Alle elektrawerk in en om huis",

  // Aanvraagwizard
  wizardLocatieTitel: "Wat is je locatie?",
  wizardHuisnummer: "Huisnummer",
  wizardPlaats: "Plaats",
  wizardStraat: "Straat",
  wizardAdresControleren: "Adres controleren...",
  wizardTypeTitel: "Type opdracht",
  wizardSoortTitel: "Soort aanvraag",
  wizardDatumTitel: "Uitvoerdatum",
  wizardIntentieTitel: "Ben je van plan dit project te laten uitvoeren?",
  wizardExtraTitel: "Aanvullende informatie (optioneel)",
  wizardExtraIntro: "Voeg extra projectdetails toe en ontvang specifiekere offertes",
  wizardOmschrijvingLabel: "Omschrijving van je klus",
  wizardOmschrijvingPlaceholder: "Bijvoorbeeld type apparaat, locatie kortsluiting, etc.",
  wizardFotosTitel: "Foto's toevoegen (optioneel)",
  wizardFotosTekst: "Met foto's van de situatie kunnen elektriciens een scherpere prijs geven.",
  wizardFotosKiezen: "Klik om foto's te kiezen of maak een foto",
  wizardFotoVerwijderen: "Foto verwijderen",
  wizardAiTitel: "Laat AI je klus samenvatten",
  wizardAiTekst:
    "We maken een korte samenvatting van je omschrijving en foto's en kiezen de passende dienstcategorie. Je eigen tekst blijft altijd bewaard.",
  wizardAiBezig: "Bezig met analyseren…",
  wizardAiKnop: "Analyseer met AI",
  wizardAiFout: "De analyse lukte niet.",
  wizardSamenvatting: "Samenvatting",
  wizardCategorie: "Dienstcategorie:",
  wizardCategorieHint: "(ingevuld bij type opdracht)",
  wizardNaamTitel: "Wat is je naam?",
  wizardVoornaam: "Voornaam",
  wizardAchternaam: "Achternaam",
  wizardContactTitel: "Contact informatie",
  wizardContactIntro:
    "In de volgende stap verifiëren we je telefoonnummer om ervoor te zorgen dat de juiste gegevens worden gedeeld met de geselecteerde vakspecialisten.",
  wizardTelefoon: "Telefoonnummer",
  wizardEmail: "E-mailadres",
  wizardVerifieerTitel: "Verifieer jouw telefoonnummer",
  wizardCodeTitel: "Vul de 4-cijferige code in",
  wizardCodeVerstuurdA: "Een",
  wizardCodeVerstuurdB: "met een 4-cijferige code is zojuist verzonden naar",
  wizardJeTelefoonnummer: "je telefoonnummer",
  wizardCodeLabel: "Verificatiecode uit de sms",
  wizardCodeLabelEmail: "Verificatiecode uit de e-mail",
  wizardCodePlaceholder: "Vul de code in",
  wizardGeenCode: "Geen code ontvangen?",
  wizardOpnieuwBezig: "Bezig met versturen…",
  wizardOpnieuw: "Opnieuw verzenden",
  wizardKlaarTitel: "Je aanvraag is verstuurd",
  wizardAccountTitel: "Je account is aangemaakt",
  wizardAccountTekst:
    "We hebben de aanvraag en aangeleverde documenten in uw account opgeslagen. U ontvangt zo een e-mail met een linkje om een nieuw wachtwoord aan te maken.",
  wizardKlaarTekstA: "We koppelen je aan passende elektriciens in",
  wizardKlaarTekstB: "Je ontvangt de offertes per e-mail op",
  wizardJeRegio: "je regio",
  wizardJeEmail: "je e-mailadres",
  wizardJouwOmschrijving: "Jouw omschrijving",
  wizardGeenOmschrijving: "(geen omschrijving ingevuld)",
  wizardFotosMeegestuurd: "foto's meegestuurd",
  wizardFotoMeegestuurd: "foto meegestuurd",
  wizardTypeOpdracht: "Type opdracht:",
  wizardAiSamenvatting: "AI-samenvatting",
  wizardTerug: "Terug naar home",
  wizardVorige: "Vorige",
  wizardVolgende: "Volgende",
  wizardVersturen: "Versturen…",
  wizardOntvangOffertes: "Ontvang offertes",
  wizardVerifieren: "Verifiëren",
  wizardVerstuurFout: "Versturen mislukt. Controleer je gegevens en probeer het opnieuw.",
  wizardSmsFout: "De sms kon niet verstuurd worden. Probeer het opnieuw.",
  wizardCodeFout: "Controle van de code lukte niet. Probeer het opnieuw.",
  wizardAdresFout: "Adrescontrole is even niet beschikbaar.",
  wizardTypeOpties: [
    "Elektra storingen oplossen",
    "Wit- of bruingoed repareren",
    "Elektra aanleggen",
    "Groepenkast aanleggen of uitbreiden",
    "Databekabeling aanleggen",
    "Laadpaal installeren",
    "Camerabeveiliging",
    "Inbraakbeveiliging (alarmsysteem)",
    "Intercom / videodeurbel",
  ],
  wizardOmschrijvingPlaceholders: [
    "Bijvoorbeeld type apparaat, locatie kortsluiting, etc.",
    "Bijvoorbeeld merk en type apparaat, en wat er misgaat.",
    "Bijvoorbeeld aantal stopcontacten, ruimte en gewenste plek.",
    "Bijvoorbeeld aantal groepen, 1- of 3-fase, laadpaal of zonnepanelen?",
    "Bijv. aantal netwerkpunten, welke kamers, glasvezel/modem in de meterkast, wifi-problemen?",
    "Bijv. afstand meterkast tot parkeerplek, 1- of 3-fase, al een laadpaal gekocht?",
    "Bijv. aantal camera's, binnen/buiten, opnemen in de cloud of op een recorder?",
    "Bijv. type woning, aantal deuren/ramen, met of zonder meldkamer?",
    "Bijv. bestaande deurbelbedrading, appartement of eengezinswoning, met app?",
  ],
  wizardSoortOpties: ["Particulier", "Zakelijk"],
  wizardDatumOpties: [
    "Binnen 1 maand",
    "Over 1 tot 3 maanden",
    "Over 3 tot 6 maanden",
    "Geen voorkeur",
  ],
  wizardIntentieOpties: [
    "Ja, na het vergelijken van de vakspecialisten",
    "Ik weet 't nog niet, afhankelijk van de informatie",
    "Nee, ik ben alleen op zoek naar informatie",
  ],

  // Vertrouwensbalk
  trustLaatsteA: "De laatste aanvraag was",
  trustLaatsteB: "7 minuten geleden",
  trustVandaagA: "Er waren vandaag",
  trustVandaagB: "201 offerteaanvragen",
  trustSsl: "SSL",
  trustSslTekst: "Beveiligde website",
};

export type Sleutel = keyof typeof nlTeksten;

const enTeksten: Record<Sleutel, string | string[] | Record<string, string>> = {
  navHome: "Home",
  navDiensten: "Services",
  navPlaatsen: "Cities",
  navHoeHetWerkt: "How it works",
  navVeelgesteldeVragen: "FAQ",
  navContact: "Contact",
  navAanmelden: "Sign up as an electrician",
  navInloggen: "Log in",
  taalKiezen: "Choose language",
  taal: "Language:",
  menuOpenen: "Open menu",
  menuSluiten: "Close menu",
  zoekPlaceholder: "Search services or cities…",
  zoekDiensten: "Services",
  zoekPlaatsen: "Cities",
  zoekGeenResultaten: "No results found",
  nieuwsTitel: "Latest news",
  nieuwsAlles: "View all articles",
  nieuwsLees: "Read article",
  nieuws1Titel: "EV charger installation: costs and options",
  nieuws1Tekst: "Want an EV charger installed at home? Explore options, indicative prices and installation considerations, and compare no-obligation quotes from electricians.",
  nieuws2Titel: "Expanding your breaker box for induction: the complete 2026 guide",
  nieuws2Tekst: "Want to expand your breaker box for induction cooking? Discover everything about the cooking circuit, 3-phase power and Perilex in this complete guide.",
  nieuws3Titel: "Perilex installation: what does it cost and what should you know?",
  nieuws3Tekst: "Installing Perilex for an induction cooktop? We tell you what it costs, what rules apply and how a certified electrician installs it safely.",
  nieuws4Titel: "Solar panels and inverter installation: costs and tips for 2026",
  nieuws4Tekst: "How much does installing solar panels with an inverter cost? Check our 2026 price guide and discover what to look out for during installation.",

  footerIntro:
    "Compare free, no-obligation quotes from certified electricians near you. One request, several prices.",
  footerPaginas: "Pages",
  footerKlussen: "Popular jobs",
  footerPlaatsen: "Popular cities",
  footerElektricien: "Electrician",

  postcode: "Postcode",
  typeKlus: "Type of job",
  gratisOffertes: "Free quotes",
  formVoetnoot: "Free · No obligation · Done in 1 minute",
  klusOpties: [
    "Replace fuse box",
    "Install EV charger",
    "Add power sockets",
    "Connect Perilex socket",
    "Rewire home",
    "Install lighting",
    "Fix a fault",
    "Security cameras",
    "Burglar alarm system",
    "Intercom / video doorbell",
    "Install data cabling",
  ],
  klusLabels: {
    "Install data cabling": "Network cabling",
  } as Record<string, string>,

  heroBadge: "Free · No obligation · Quick",
  heroTitelRegel1: "Find the best tradesperson",
  heroTitelRegel2: "for in and around your home",
  heroVoordeel1: "Certified electricians",
  heroVoordeel2: "Free and no obligation",
  heroVoordeel3: "Arranged in 1 minute",
  heroVoordeel3Mobiel: "Quickly arranged",
  heroSterrenLabel: "4.7 out of 5 stars",
  heroScore: "4.7",
  heroReviews: "average from 120+ reviews",

  hoeTitel: "How does it work?",
  hoeIntro: "Three simple steps from request to quotes from certified electricians.",
  hoeStap1Titel: "Describe your project",
  hoeStap1Tekst:
    "Enter your postcode and pick the type of work. Tell us what you need so we can match the right electricians.",
  hoeStap2Titel: "Compare electricians",
  hoeStap2Tekst:
    "We select up to 5 certified companies in your region. You receive their quotes and can compare at your own pace.",
  hoeStap3Titel: "Choose your electrician",
  hoeStap3Tekst:
    "Compare price, planning and reviews. You decide who to hire, or do nothing with the quotes at all.",
  hoeKnop: "Start your request →",

  uspBesparenTitel: "Save up to 40%",
  uspBesparenTekst: "Prices from several electricians side by side.",
  uspMinuutTitel: "Done in 1 minute",
  uspMinuutTekst: "Your postcode and the job is all we need.",
  uspVakmensenTitel: "SmarthomeOffertes.com",
  uspVakmensenTekst: "Vetted companies with reviews.",
  uspKaart4Titel: "Save up to 40%",
  uspKaart4Tekst: "Prices from several electricians side by side.",
  uspKaart5Titel: "Done in 1 minute",
  uspKaart5Tekst: "Your postcode and the job is all we need.",
  uspKaart6Titel: "SmarthomeOffertes.com",
  uspKaart6Tekst: "Vetted companies with reviews.",
  iconPortemonnee: "Wallet icon",
  iconKlok: "Clock icon",
  iconDocument: "Document icon",

  kostenEyebrow: "Guide prices",
  kostenTitel: "What does an electrician cost?",
  kostenIntro:
    "Indicative prices including materials and labour. The actual price depends on your home and situation. Compare quotes from reliable companies and save up to 40% on your project.",
  kostenBespaar: "Save up to 40% by comparing quotes side by side.",
  kostenLink: "View all services",
  kostenKolomKlus: "Job",
  kostenKolomPrijs: "Guide price",
  klusGroepenkast: "Replace fuse box",
  klusLaadpaal: "Install EV charger",
  klusStopcontact: "Add a power socket",
  klusHerbedraden: "Rewire home",
  klusVerlichting: "Install lighting",
  klusStoring: "Fix a fault",

  reviewsEyebrow: "Experiences",
  reviewsTitel: "What customers say",
  reviewsScore: "4.7 / 5",
  review1: "Within an hour I had three quotes in my inbox. It saved me hundreds of euros.",
  review1Naam: "Frans J., Utrecht",
  review2: "Great that you can compare before choosing someone. Fast and tidy service.",
  review2Naam: "X. Schouten, Breda",

  ctaTitel: "Get free quotes and save up to 40%",
  ctaTekst: "Enter your postcode and receive no-obligation prices from electricians in your region.",
  ctaVink1: "Free and without obligation",
  ctaVink2: "Requested within 5 minutes",

  netwerkTitel: "Part of the Offertes network",
  netwerkIntro: "Specialised comparison sites for every type of installation.",
  netwerkThuisbatterij: "Have a home battery installed",
  netwerkWarmtepomp: "Compare heat pump quotes",
  netwerkBeveiliging: "Alarms, cameras and intercoms",
  netwerkGroepenkast: "Replace or extend your fuse box",
  netwerkSmarthome: "Smart lighting and home automation",
  netwerkElektricien: "All electrical work in and around the house",

  wizardLocatieTitel: "What is your location?",
  wizardHuisnummer: "House number",
  wizardPlaats: "City",
  wizardStraat: "Street",
  wizardAdresControleren: "Checking address...",
  wizardTypeTitel: "Type of job",
  wizardSoortTitel: "Type of request",
  wizardDatumTitel: "Preferred date",
  wizardIntentieTitel: "Are you planning to have this project carried out?",
  wizardExtraTitel: "Additional information (optional)",
  wizardExtraIntro: "Add extra project details and receive more precise quotes",
  wizardOmschrijvingLabel: "Description of your job",
  wizardOmschrijvingPlaceholder: "For example the type of appliance, where the fault is, etc.",
  wizardFotosTitel: "Add photos (optional)",
  wizardFotosTekst: "With photos of the situation electricians can give a sharper price.",
  wizardFotosKiezen: "Click to choose photos or take a photo",
  wizardFotoVerwijderen: "Remove photo",
  wizardAiTitel: "Let AI summarise your job",
  wizardAiTekst:
    "We create a short summary of your description and photos and pick the matching service category. Your own text is always kept.",
  wizardAiBezig: "Analysing…",
  wizardAiKnop: "Analyse with AI",
  wizardAiFout: "The analysis did not work.",
  wizardSamenvatting: "Summary",
  wizardCategorie: "Service category:",
  wizardCategorieHint: "(filled in under type of job)",
  wizardNaamTitel: "What is your name?",
  wizardVoornaam: "First name",
  wizardAchternaam: "Last name",
  wizardContactTitel: "Contact details",
  wizardContactIntro:
    "In the next step we verify your phone number so the right details are shared with the selected professionals.",
  wizardTelefoon: "Phone number",
  wizardEmail: "Email address",
  wizardVerifieerTitel: "Verify your phone number",
  wizardCodeTitel: "Enter the 4-digit code",
  wizardCodeVerstuurdA: "An",
  wizardCodeVerstuurdB: "with a 4-digit code has just been sent to",
  wizardJeTelefoonnummer: "your phone number",
  wizardCodeLabel: "Verification code from the text message",
  wizardCodeLabelEmail: "Verification code from the email",
  wizardCodePlaceholder: "Enter the code",
  wizardGeenCode: "No code received?",
  wizardOpnieuwBezig: "Sending…",
  wizardOpnieuw: "Send again",
  wizardKlaarTitel: "Your request has been sent",
  wizardAccountTitel: "Your account has been created",
  wizardAccountTekst:
    "We saved your request and the documents you provided in your account. You will shortly receive an email with a link to set a new password.",
  wizardKlaarTekstA: "We are matching you with suitable electricians in",
  wizardKlaarTekstB: "You will receive the quotes by email at",
  wizardJeRegio: "your region",
  wizardJeEmail: "your email address",
  wizardJouwOmschrijving: "Your description",
  wizardGeenOmschrijving: "(no description entered)",
  wizardFotosMeegestuurd: "photos included",
  wizardFotoMeegestuurd: "photo included",
  wizardTypeOpdracht: "Type of job:",
  wizardAiSamenvatting: "AI summary",
  wizardTerug: "Back to home",
  wizardVorige: "Previous",
  wizardVolgende: "Next",
  wizardVersturen: "Sending…",
  wizardOntvangOffertes: "Get quotes",
  wizardVerifieren: "Verify",
  wizardVerstuurFout: "Sending failed. Check your details and try again.",
  wizardSmsFout: "The text message could not be sent. Please try again.",
  wizardCodeFout: "Checking the code did not work. Please try again.",
  wizardAdresFout: "The address check is temporarily unavailable.",
  wizardTypeOpties: [
    "Fix electrical faults",
    "Repair white or brown goods",
    "Install electrical wiring",
    "Install or extend a fuse box",
    "Install data cabling",
    "Install EV charger",
    "Security cameras",
    "Burglar alarm system",
    "Intercom / video doorbell",
  ],
  wizardOmschrijvingPlaceholders: [
    "For example the type of appliance, where the fault is, etc.",
    "For example the brand and type of appliance, and what goes wrong.",
    "For example the number of sockets, the room and the desired spot.",
    "For example the number of circuits, 1- or 3-phase, EV charger or solar panels?",
    "E.g. number of network points, which rooms, fibre/modem in the meter cupboard, wifi problems?",
    "E.g. distance from fuse box to parking spot, 1- or 3-phase, charger already bought?",
    "E.g. number of cameras, indoor/outdoor, recording in the cloud or on a recorder?",
    "E.g. type of home, number of doors/windows, with or without monitoring centre?",
    "E.g. existing doorbell wiring, apartment or single-family home, with app?",
  ],
  wizardSoortOpties: ["Private", "Business"],
  wizardDatumOpties: [
    "Within 1 month",
    "In 1 to 3 months",
    "In 3 to 6 months",
    "No preference",
  ],
  wizardIntentieOpties: [
    "Yes, after comparing the professionals",
    "Not sure yet, depends on the information",
    "No, I am only looking for information",
  ],

  trustLaatsteA: "The last request was",
  trustLaatsteB: "7 minutes ago",
  trustVandaagA: "Today there were",
  trustVandaagB: "201 quote requests",
  trustSsl: "SSL",
  trustSslTekst: "Secure website",
};

export const vertalingen: Record<TaalCode, Record<Sleutel, string | string[] | Record<string, string>>> = {
  nl: nlTeksten,
  en: enTeksten,
};

export function vertaal<K extends Sleutel>(taal: TaalCode, sleutel: K): (typeof nlTeksten)[K] {
  return vertalingen[taal][sleutel] as (typeof nlTeksten)[K];
}
